import React, { useMemo } from 'react';
import styles from './Common.module.scss';
import { useLocation, useHistory } from 'react-router-dom';
import { imageBasePath } from 'constants';
import { ProgressBar } from 'shared_ui_components';
import { format, parseISO } from 'date-fns';
import { Avatar } from '@material-ui/core';
import User from 'infrastructure/User';
import RealPlayRecordDataHelper from 'features/realplays/RealPlayRecordData.helper';

const SubmitRealPlayHeader = ({ data }) => {
  let location = useLocation();
  let history = useHistory();

  const { scenarios, title } = RealPlayRecordDataHelper();

  const handleBack = () => {
    history.push({
      pathname: `/roleplay`,
      state: {
        prevPath: `${location.pathname}${location.search ? location.search : ''}`,
      },
    });
  };

  const scenariosCompleted = useMemo(
    () => scenarios?.filter((item) => item?.response && item?.response?.video)?.length,
    [scenarios]
  );

  return (
    <div className={styles.roleplayHeader}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
          <button onClick={handleBack} className={styles.backBtn}>
            <img src={imageBasePath + 'back_arrow.svg'} alt="img" />
          </button>
          <p className="heading4">{title || ''}</p>
        </div>
        <div>
          <span className={`${styles.value} heading6`}>
            {`${scenariosCompleted || 0}/${scenarios?.length || 0}`}{' '}
          </span>
          <span className="supportText" style={{ marginTop: 2 }}>
            Scenarios completed
          </span>
          <ProgressBar
            inProgress
            value={(scenariosCompleted * 100) / scenarios?.length}
            max={100}
            hideLabel={true}
          />
        </div>
      </div>

      {!!Object.keys(data)?.length > 0 && (
        <div className={`${styles.description_header} ${styles.description_header_submit}`}>
          <div>
            <div className={styles.description_header_title}>Assigned</div>
            <div className={styles.avatar}>
              <Avatar className={styles.img} alt="" src={data?.assigned_by_user?.profile_pic}>
                {User.getInitial(data?.assigned_by_user)}
              </Avatar>
              <h4>{User.getUserName(data?.assigned_by_user)}</h4>
            </div>
          </div>
          <div>
            <div className={styles.description_header_title}>Due Date</div>
            <h4 style={{ marginTop: '1rem' }}>
              {format(parseISO(data?.deadline), 'MMM dd, yyyy')}
            </h4>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubmitRealPlayHeader;
